import { useState } from 'react';
import httpCommon from './http-common';

export default function useToken() {
  const getToken = () => {
    return httpCommon.loadAuthTokenFromStorage();
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    if (userToken) {
      httpCommon.saveAuthTokenToStorage(userToken);
      setToken(userToken);
    } else {
      httpCommon.clearAuthTokenFromStorage();
      setToken(null);
    }
  };

  return {
    setToken: saveToken,
    token
  }
}